import { atom } from "jotai";
import React from "react";

export const layoutAtom = atom<boolean>(true);
export const modalListAtom = atom<React.ReactNode[]>([]);
export const topLayerAtom = atom<React.ReactNode>(null);
export const isLoggedInAtom = atom<boolean>(false);
export const selectedProjectUuidAtom = atom<string | null>(null);
export const selectedSubprojectUuidAtom = atom<string | null>(null);
